import React from 'react';
import { Box, AbsoluteView, Button } from 'modules/styled';
import { Beacon } from 'react-native-help-scout';
import { TabNavigator, TabContainer } from './tabRouter';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

Beacon.init('40ed799c-8c6c-4226-9215-5adfd59e35eb');

const TabContainerWithHelp = (props) => {
  const { bottom } = useSafeAreaInsets();
  return (
    <Box sx={{ flex: 1 }}>
      <TabContainer {...props} />
      <AbsoluteView sx={{ bottom: bottom + 8 * 8, right: 2, zIndex: 10 }}>
        <Button
          onPress={() => Beacon.open()}
          sx={{ borderRadius: 2 * 8, height: 5, minWidth: [0, 0] }}
        >
          Help
        </Button>
      </AbsoluteView>
    </Box>
  );
};

TabContainerWithHelp.router = TabNavigator.router;

export default TabContainerWithHelp;
